@if (showHeader()) {
  <!-- PLANT AND LOADING POINT -->
  <div class="cyc-mixing__header">
    <img
      class="cyc-mixing__header__logo"
      src="assets/logos/cloudcycle.svg"
      alt="Cloud Cycle"
      aria-disabled="true"
    />
    <span class="cyc-mixing__header__plant" data-test-id="plant-name">{{
      plant()
    }}</span>
    <span
      class="cyc-mixing__header__loading-point"
      data-test-id="loading-point"
      >{{ loadingPoint() }}</span
    ></div
  >
}
@if (onLine()) {
  @if (mixingEvent()) {
    <!-- OVERVIEW -->
    <div
      class="cyc-mixing__overview"
      [class.cyc-mixing__overview--in-progress]="inProgress()"
    >
      <span class="cyc-mixing__overview__heading">
        @if (registration(); as registration) {
          <img
            src="assets/icons/truck-two-tone.svg"
            alt="Mixing icon"
            class="cyc-icon cyc-mixing__overview__icon cyc-icon--rtl-mirror"
            (dblclick)="toggleDebug()"
          />
          <span data-test-id="truck-registration">{{
            registration | uppercase
          }}</span>
        } @else {
          <img
            src="assets/icons/loading-two-tone.png"
            alt="Mixing icon"
            class="cyc-icon cyc-mixing__overview__icon"
            (dblclick)="toggleDebug()"
          />
          <span i18n="@@mixing-procedure">Mixing Procedure</span>
        }
      </span>
      <cyc-mixing-status
        class="cyc-mixing__overview__status"
        [mixingEvent]="mixingEvent()"
      ></cyc-mixing-status>
      <cyc-mixing-dots
        class="cyc-mixing__overview__dots"
        [mixingEvent]="mixingEvent()"
      ></cyc-mixing-dots>
    </div>
  }
  @if (showSuccess()) {
    <div class="cyc-mixing__message" data-test-id="success-message">
      <span class="text-success self-center cyc-mixing__message__icon"
        >&#10003;</span
      >
      <div class="cyc-mixing__message__text" i18n="@@mixing-success-message"
        >Mixing completed successfully</div
      >
    </div>
  } @else if (inProgress()) {
    <!-- ACTUAL AND REQUIRED DRUM SPEED -->
    <div class="cyc-mixing__current">
      <!-- CURRENT SPEED -->
      <div class="cyc-mixing__speed-current">
        <div class="cyc-mixing__speed-current__heading" i18n="@@drum-speed"
          >Drum Speed</div
        >
        <div class="flex flex-row gap-4 items-center justify-between grow">
          <div class="cyc-mixing__speed-current__spinner-container">
            <span class="cyc-mixing__speed-current__spinner-ring"></span>
            <span class="cyc-mixing__speed-current__value-container">
              <span class="cyc-mixing__speed-current__number">
                @if (drumSpeed(); as drumSpeed) {
                  {{ drumSpeed | cycRpm: true }}
                } @else {
                  -.-
                }
              </span>
              <span class="cyc-mixing__speed-current__rpm">RPM</span>
            </span>
          </div>

          @if (speedStatus() === 'slow') {
            <span class="grow flex flex-col items-center">
              <span
                class="text-error self-center cyc-mixing__speed-current__icon"
                >&#8593;</span
              >
              <span
                class="cyc-mixing__speed-current__message"
                i18n="@@increase-speed"
                >Increase speed</span
              >
            </span>
          } @else if (speedStatus() === 'fast') {
            <span class="grow flex flex-col items-center">
              <span
                class="text-error self-center cyc-mixing__speed-current__icon"
                >&#8595;</span
              >
              <span
                class="cyc-mixing__speed-current__message"
                i18n="@@decrease-speed"
                >Decrease speed</span
              >
            </span>
          } @else if (speedStatus() === 'in_range') {
            <span class="grow flex flex-col items-center">
              <span
                class="text-success self-center cyc-mixing__speed-current__icon"
                >&#10003;</span
              >
              <span
                class="cyc-mixing__speed-current__message"
                i18n="@@maintain-speed"
                >Maintain speed</span
              >
            </span>
          }
        </div>
      </div>

      <!-- INSTRUCTIONS -->
      <div class="cyc-mixing__instruction">
        <span
          class="cyc-mixing__instruction__words"
          i18n="@@keep-drum-speed-within"
        >
          Drum Speed Target</span
        >
        <div class="cyc-mixing__instruction__value-container">
          <span class="cyc-mixing__instruction__number"
            >{{ currentStage()?.rpmMin }} - {{ currentStage()?.rpmMax }}</span
          >
          <span class="cyc-mixing__instruction__rpm">RPM</span>
        </div>
      </div>
    </div>
    <!-- PROGRESS BAR -->
    <div class="cyc-mixing__progress">
      <cyc-progress-bar
        [value]="percentComplete()"
        [responsive]="responsive()"
        [maxWidth]="false"
        [showPercentage]="false"
      >
        <ng-container i18n="@@remaining-mixing-time"
          >Remaining Mixing Time</ng-container
        >: {{ secondsRemaining() }}
        <ng-container i18n="@@seconds">seconds</ng-container>
      </cyc-progress-bar>
    </div>
  } @else if (showWaiting()) {
    <div class="cyc-mixing__message">
      <div
        class="cyc-mixing__message__text"
        i18n="@@waiting-for-next-truck"
        data-test-id="waiting-message"
        >Waiting for next truck</div
      >
    </div>
  }
  @if (debug()) {
    <div class="cyc-mixing__debug text-xs">
      @if (
        mixingEvent().speedPattern[mixingEvent().currentStageIndex];
        as currentStage
      ) {
        <div>Stage Target: {{ currentStage.secondsTarget }}</div>
        <div>Stage Elapsed: {{ currentStage.secondsElapsed }}</div>
        <div>Stage status: {{ currentStage.status }}</div>
        <div
          >Stage Start:
          {{ currentStage.startTimestamp?.split('T')[1]?.split('.')[0] }}</div
        ><div>Stage Status: {{ currentStage.status }}</div>
      }
      <div
        >Last update:
        {{
          mixingEvent()?.lastUpdateTimestamp?.split('T')[1]?.split('.')[0]
        }}</div
      >
      <div>Drum Speed: {{ drumSpeed() }}</div>
    </div>
  }
} @else {
  <!-- OFFLINE -->
  <div class="cyc-mixing__message">
    <span class="cyc-mixing__message__icon">&#9888;</span>
    <span class="cyc-mixing__message__text" i18n="@@offline">Offline</span>
  </div>
}
